<template>
    <ViewBonCommandeFournisseur/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ViewBonCommandeFournisseur from "@/components/GesCom/BonCommandeFournisseur/ViewBonCommandeFournisseur.vue";

    export default defineComponent({
      name: "ViewBonCommandeFournisseurPage",
      components: {
        ViewBonCommandeFournisseur,
      },
    });
  </script>